import RequestContainer from 'components/containers/request.container';
import SubpageContainer from 'components/containers/subpage.container';
import Table from 'components/tables/table';
import TableBody from 'components/tables/table-body';
import TableShimmer from 'pages/users/magic-links/magic-link.shimmer';
import { useAppSelector } from '../../../../redux/hooks';
import { selectChatbotSettings } from './chatbot-settings.slice';
import TablePagination from '../../../../components/tables/table.pagination';
import React, { useState } from 'react';
import { useChatbotSettings } from './chatbot-settings.hooks';
import ChatbotSettingsTabledata from './chatbot-settings.tabledata';

const headers = ['name', 'url', 'path', 'environment', 'Action'];

const ChatbotSettings = () => {
  const [currentPage, setCurrentPage] = useState<number>(1);

  const { isFetching } = useChatbotSettings(currentPage, 'chatbot-settings' + currentPage);
  const columns = ChatbotSettingsTabledata();
  const colSpan = headers.length;

  const { docs, hasNextPage, hasPrevPage, nextPage, page, pagingCounter, prevPage, totalPages } =
    useAppSelector(selectChatbotSettings);
  return (
    <>
      <SubpageContainer title="Chatbot Settings" showAdd addUrl="new" showAddString="Add Setting">
        <Table headers={headers}>
          <RequestContainer
            loading={isFetching}
            fallback={<TableShimmer headers={headers} span={colSpan} />}
            colSpan={colSpan}
            data={docs}
            noDataMsg="No Settings"
            buttonLabel="New Setting"
          >
            <TableBody columns={columns} data={docs} deleteUrl="/sqp/admin/seller-settings/" confirmField="name" />
          </RequestContainer>
        </Table>
        <TablePagination
          setCurrentPage={setCurrentPage}
          hasNextPage={hasNextPage}
          hasPrevPage={hasPrevPage}
          nextPage={nextPage}
          page={page}
          pagingCounter={pagingCounter}
          prevPage={prevPage}
          totalPages={totalPages}
          docs={docs?.length}
        />
      </SubpageContainer>
    </>
  );
};

export default ChatbotSettings;
